import type { InvoicePaymentState, SupplierPaymentMethod } from "../api/types";

/** G-121 S4 (OD-146): CRM wording for a factura's paid state and payments. */

export const SUPPLIER_PAYMENT_METHODS: readonly SupplierPaymentMethod[] = [
  "BANK_TRANSFER",
  "DIRECT_DEBIT",
  "CARD",
  "CASH",
];

const METHOD_LABELS: Record<SupplierPaymentMethod, string> = {
  BANK_TRANSFER: "Bank transfer",
  DIRECT_DEBIT: "Direct debit",
  CARD: "Card",
  CASH: "Cash",
};

export function paymentMethodLabel(method: SupplierPaymentMethod): string {
  return METHOD_LABELS[method];
}

const STATE_LABELS: Record<InvoicePaymentState, string> = {
  PAID_WHEN_ORDERED: "Paid when ordered",
  UNPAID: "Not paid yet",
  PART_PAID: "Part paid",
  PAID: "Paid",
  TOTAL_NOT_READ: "Not paid yet — total not read",
};

export function paymentStateLabel(state: InvoicePaymentState): string {
  return STATE_LABELS[state];
}

/** The badge modifier for a state (`.badge.<tone>`). */
export function paymentStateTone(state: InvoicePaymentState): "success" | "warning" | "danger" | "muted" {
  switch (state) {
    case "PAID":
    case "PAID_WHEN_ORDERED":
      return "success";
    case "PART_PAID":
      return "warning";
    case "UNPAID":
    case "TOTAL_NOT_READ":
      return "danger";
  }
}
